const SUPERUSER = document.documentElement.getAttribute( 'data-superuser' ) == '1' ? true : false
export default SUPERUSER